import { createBaseResponseErrors } from '@/utils/errors/baseResponseErrors'
import { createBaseCRUDApi, createBaseFilesApi } from '@/api/base'
import { PTO_URL } from '../../const'
export * from './own-production'
export * from './fot-production'
export * from './work-sign'

export const PTO_ESTIMATE_URL = `${PTO_URL}/estimate`

const errors = createBaseResponseErrors('смету', 'смет')

export const PTOEstimateApi = {
  ...createBaseCRUDApi(PTO_ESTIMATE_URL, errors),
  ...createBaseFilesApi(PTO_ESTIMATE_URL)
}
